export const parametersDB = {
  "1-Investor Ratio": [
    {
      name: "share_price",
    },
    {
      name: "EPS",
    },
    {
      name: "dividends_per_share",
    },
    {
      name: "net_borrowings",
    },
    {
      id: 54,
      name: "Test ",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"eps","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"share_price","mType":"ql"},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 53,
      name: "Earnings per Shareholder ",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"net_profits","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"total_number_of_issued_shares","mType":"ql"},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "absolute-values",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 28,
      name: "PE Ratio - Quarterly ",
      equation:
        '[{"type":"metric","value":"share_price","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"eps","mType":"ltm"}]',
      status: 1,
      type: "multiples",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 33,
      name: "Dividend Yield ",
      equation:
        '[{"type":"operator","value":"(","mType":"ltm"},{"type":"metric","value":"dividends_per_share","mType":"ql"},{"type":"operator","value":"/","mType":"ql"},{"type":"metric","value":"share_price","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 34,
      name: "Dividend Payout",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"dividends_per_share","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"eps","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 49,
      name: "DPS (LTM)",
      equation:
        '[{"type":"metric","value":"dividends_per_share","mType":"ltm"}]',
      status: 1,
      type: "absolute-values",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 48,
      name: "Dividend Payout (LTM) ",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"dividends_per_share","mType":"ltm"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"eps","mType":"ltm"},{"type":"operator","value":")","mType":""},{"type":"numeric","value":"*","mType":"ltm"},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 47,
      name: "Dividend Yield (LTM)",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"dividends_per_share","mType":"ltm"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"share_price","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
    {
      id: 44,
      name: "Price to Book Ratio ",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"share_price","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"book_value","mType":"ql"},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "multiples",
      metric_category_id: 1,
      metric_category_name: "Investor Ratio",
      metric_order: 1,
    },
  ],
  "5-Efficiency": [
    {
      name: "trade_payables",
    },
    {
      id: 40,
      name: "Payable Days ",
      equation:
        '[{"type":"numeric","value":"365","mType":""},{"type":"operator","value":"/","mType":""},{"type":"operator","value":"((","mType":""},{"type":"metric","value":"revenues","mType":"ltm"},{"type":"operator","value":"-","mType":""},{"type":"metric","value":"gross_profits","mType":"ltm"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"/","mType":"ql"},{"type":"metric","value":"trade_payables","mType":"ql"},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "days",
      metric_category_id: 4,
      metric_category_name: "Efficiency",
      metric_order: 5,
    },
    {
      id: 39,
      name: "Receivable Days ",
      equation:
        '[{"type":"numeric","value":"365","mType":""},{"type":"operator","value":"/","mType":""},{"type":"operator","value":"(","mType":""},{"type":"metric","value":"revenues","mType":"ltm"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"trade_receivables","mType":"ql"},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "days",
      metric_category_id: 4,
      metric_category_name: "Efficiency",
      metric_order: 5,
    },
    {
      id: 45,
      name: "Quick Ratio ",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"total_current_assets","mType":"ql"},{"type":"operator","value":"-","mType":""},{"type":"metric","value":"inventories","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"total_current_liabilities","mType":"ql"}]',
      status: 1,
      type: "multiples",
      metric_category_id: 4,
      metric_category_name: "Efficiency",
      metric_order: 5,
    },
    {
      id: 38,
      name: "Inventory Days ",
      equation:
        '[{"type":"numeric","value":"365","mType":""},{"type":"operator","value":"/","mType":""},{"type":"operator","value":"((","mType":""},{"type":"metric","value":"revenues","mType":"ltm"},{"type":"operator","value":"-","mType":""},{"type":"metric","value":"gross_profits","mType":"ltm"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"inventories","mType":"ql"},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "days",
      metric_category_id: 4,
      metric_category_name: "Efficiency",
      metric_order: 5,
    },
    {
      id: 26,
      name: "Current Assets Ratio",
      equation:
        '[{"type":"metric","value":"total_current_assets","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"total_current_liabilities","mType":"ql"}]',
      status: 1,
      type: "multiples",
      metric_category_id: 4,
      metric_category_name: "Efficiency",
      metric_order: 5,
    },
  ],
  "6-Balance Sheet": [
    {
      name: "total_current_liabilities",
    },
    {
      name: "fixed_assets",
    },
    {
      name: "trade_receivables",
    },
    {
      name: "total_debt",
    },
    {
      name: "inventories",
    },
    {
      name: "total_equity",
    },
    {
      name: "total_current_assets",
    },
    {
      name: "cash",
    },
    {
      name: "book_value",
    },
    {
      name: "total_liabilities",
    },
    {
      name: "total_assets",
    },
  ],
  "7-Income Statement": [
    {
      name: "gross_profits",
    },
    {
      name: "operating_profit",
    },
    {
      name: "profit_before_tax",
    },
    {
      name: "interest_income",
    },
    {
      name: "test",
    },
    {
      name: "amortization",
    },
    {
      name: "depreciation",
    },
    {
      name: "taxation",
    },
    {
      name: "interest_expense",
    },
    {
      name: "revenues",
    },
    {
      name: "net_profits",
    },
    {
      id: 35,
      name: "EBITDA ",
      equation:
        '[{"type":"metric","value":"operating_profit","mType":"ql"},{"type":"operator","value":"+","mType":""},{"type":"metric","value":"depreciation","mType":"ql"},{"type":"operator","value":"+","mType":""},{"type":"metric","value":"amortization","mType":"ql"}]',
      status: 1,
      type: "absolute-values",
      metric_category_id: 6,
      metric_category_name: "Income Statement",
      metric_order: 7,
    },
  ],
  "8-Cash Flow": [
    {
      name: "capital_expenditure",
    },
    {
      name: "cash_from_financing_activities",
    },
    {
      name: "cash_from_investing_activities",
    },
    {
      name: "cash_from_operating_activities",
    },
    {
      id: 50,
      name: "Net Change in Cash",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"cash_from_operating_activities","mType":"ql"},{"type":"operator","value":"+","mType":""},{"type":"metric","value":"cash_from_investing_activities","mType":"ql"},{"type":"operator","value":"+","mType":"ltm"},{"type":"metric","value":"cash_from_financing_activities","mType":"ql"},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "absolute-values",
      metric_category_id: 7,
      metric_category_name: "Cash Flow",
      metric_order: 8,
    },
  ],
  "2-Profitability": [
    {
      id: 41,
      name: "Gross Profit Margin %",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"gross_profits","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"revenues","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 52,
      name: "EBITDA to Asset",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"ebitda ","mType":"ltm"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"total_assets","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 51,
      name: "Revenue per Share",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"revenues","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"total_number_of_issued_shares","mType":"ql"},{"type":"operator","value":")","mType":""}]',
      status: 1,
      type: "absolute-values",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 43,
      name: "PBT Margin %",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"profit_before_tax","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"revenues","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 42,
      name: "Operating Profit Margin %",
      equation:
        '[{"type":"operator","value":"(","mType":"ql"},{"type":"metric","value":"operating_profit","mType":"ql"},{"type":"operator","value":"/","mType":"ql"},{"type":"metric","value":"revenues","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 24,
      name: "Return on Equity",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"net_profits","mType":"ltm"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"total_equity","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 36,
      name: "EBITDA Margin",
      equation:
        '[{"type":"operator","value":"(","mType":"ql"},{"type":"metric","value":"ebitda ","mType":"ql"},{"type":"operator","value":"/","mType":"ql"},{"type":"metric","value":"revenues","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 32,
      name: "Return on Asset",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"net_profits","mType":"ltm"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"total_assets","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 27,
      name: "Operating Cash Margin %",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"cash_from_operating_activities","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"revenues","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
    {
      id: 25,
      name: "Net Profit Margin %",
      equation:
        '[{"type":"operator","value":"(","mType":""},{"type":"metric","value":"net_profits","mType":"ql"},{"type":"operator","value":"/","mType":""},{"type":"metric","value":"revenues","mType":"ql"},{"type":"operator","value":")","mType":""},{"type":"operator","value":"*","mType":""},{"type":"numeric","value":"100","mType":""}]',
      status: 1,
      type: "percentages",
      metric_category_id: 2,
      metric_category_name: "Profitability",
      metric_order: 2,
    },
  ],
};
